import React from 'react'
import PropTypes from 'prop-types'
import CSS from './index.module.css'
import iconArrowRightYellow from '@assets/icon/icon-arrow-right-yellow.png'

class ProductUseProcess extends React.Component {
	render() {
		let title = this.props.title || '使用流程'
		let array = this.props.array || []
		let sectionStyle = this.props.sectionStyle || {}
		let titleStyle = this.props.titleStyle || {}

		return (
			<div className={CSS.section} style={sectionStyle}>
				<p className={CSS.sectionTitle} style={titleStyle}>
					{title}
				</p>
				<div className={CSS.sectionContent}>
					{array.map((item, index) => {
						if (index === this.props.array.length - 1) {
							return (
								<div key={index} className={CSS.sectionItem}>
									<div>
										<img className={CSS.sectionItemImg} src={item.src} alt='' />
										<p className={CSS.sectionItemC}>{item.name}</p>
									</div>
								</div>
							)
						} else {
							return (
								<React.Fragment key={index}>
									<div className={CSS.sectionItem}>
										<img className={CSS.sectionItemImg} src={item.src} alt='' />
										<p className={CSS.sectionItemC}>{item.name}</p>
									</div>
									<div className={CSS.sectionItem2}>
										<img src={iconArrowRightYellow} alt='' />
									</div>
								</React.Fragment>
							)
						}
					})}
				</div>
			</div>
		)
	}
}

ProductUseProcess.propTypes = {
	title: PropTypes.string,
	array: PropTypes.array,
	sectionStyle: PropTypes.object,
	titleStyle: PropTypes.object,
}

// 产品使用流程
export default ProductUseProcess
